export function toPluginModel(key, source, label) {
    return { key, source, label };
}
